import { Osoba } from './osoba';
import { BaseDataService, TabsContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent } from 'yt-ng-framework';

@Component({
  selector: 'yt-osoba-tab-update',
  templateUrl: './osoba-tab-update.component.html',
})
export class OsobaTabUpdateComponent extends BaseTabsUpdateComponent<Osoba> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<Osoba>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  saveDisabled: boolean = false;
  ngOnInit() {
    super.ngOnInit();
    this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
    this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;
  }
  Reset(): void {
    this.baseUpdateComponent.Reset(true).subscribe((result) => {
      if (result) {
        // console.log('Restore successfully executed');
      } else {
        // console.log('Restore was cancelled by the user');
      }
    });
  }
  }


